import { useMemo } from "react";
import { Table } from "react-bootstrap";
import { TimeFormatter, useTime } from "../common/time/useTime";
import { useCalendar } from "./CalendarContext";
import { getPostDate } from "./calendar.utils";
import { useSuspensePosts, useSuspensePostsListRange } from "./usePosts";

export const CalendarList = () => {
	const { filterPosts, days } = useCalendar();
	const { IDs } = useSuspensePostsListRange(days[0], days[days.length - 1]);
	const posts = useSuspensePosts(IDs);
	const { format } = useTime();

	const items = useMemo(() => filterPosts(posts), [posts, filterPosts]);

	return (
		<Table>
			<thead>
				<tr>
					<th>Date</th>
					<th>Content</th>
					<th>Platform</th>
					<th>Status</th>
				</tr>
			</thead>
			<tbody>
				{items.map((x) => (
					<tr key={x.id}>
						<td>{format(TimeFormatter.DateTime, getPostDate(x))}</td>
						<td>
							{x.subject.trim() && (
								<>
									{x.subject.trim()}
									<br />
								</>
							)}
							<small className="text-muted">{x.content}</small>
						</td>
						<td>{x.platform}</td>
						<td>{x.status}</td>
					</tr>
				))}
				{items.length === 0 && (
					<tr>
						<td colSpan={4} className="text-muted text-center">
							No posts created yet.
						</td>
					</tr>
				)}
			</tbody>
		</Table>
	);
};
